import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ColorPickerComponent } from '../color-picker/color-picker.component';
import { TreeSelectorComponent } from '../tree-selector/tree-selector.component';
import { CommonModule } from '@angular/common';
import { MaterialListControllerService } from '../../services/material-list-controller/material-list-controller.service';
import { CanvasControllerService } from '../../../../../../services/canvas-controller/canvas-controller.service';

@Component({
  selector: 'wrap-tool',
  imports: [CommonModule, ColorPickerComponent, TreeSelectorComponent],
  templateUrl: './wrap-tool.component.html',
  styleUrl: './wrap-tool.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WrapToolComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    private materialListController: MaterialListControllerService,
    private canvasController: CanvasControllerService,
  ) {}
  //--------------------------------------------------------------------------------
  // @ Lifecycle hooks
  //--------------------------------------------------------------------------------
  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  //--------------------------------------------------------------------------------
  // @ Public methods
  //--------------------------------------------------------------------------------

  public changeSelectedMaterials(materialNames: any): void {
    this.materialListController.materialList = materialNames;
  }

  public onChangeColor(color: string): void {
    this.canvasController.materialsColorChange(this.materialListController.materialList, color);
  }

  public onChangeMatte(isMatte: boolean): void {
    this.canvasController.materialsMatteChange(this.materialListController.materialList, isMatte);
  }
}
